var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPpg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3863_203323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6663 15.3333L27.333 14L19.333 40.6667L25.333 42.6667L31.333 39.3333L36.6663 37.3333L50.6663 22.6667L48.6663 15.3333Z",
    fill: "#C1FF05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4186 57.3332H6.66699L20.392 6.6665H46.1685C55.1462 6.6665 60.4968 13.8894 58.0908 22.7742C55.6848 31.6589 46.4199 38.8818 37.4423 38.8818H33.8081L33.5065 39.6844C31.3375 45.4087 25.8073 49.2012 19.6235 49.2012L17.4186 57.3332V57.3332ZM22.5035 38.5693H32.7811L35.4169 31.6163C36.1854 29.5922 38.1389 28.2499 40.3223 28.2499C43.3747 28.2499 46.5205 25.7926 47.3392 22.7742C48.158 19.7557 46.3409 17.2984 43.2885 17.2984H28.2636L22.5035 38.5622V38.5693Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3863_203323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50.6667,
    fill: "white",
    transform: "translate(6.66699 6.6665)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPpg);
export default __webpack_public_path__ + "static/media/logo_ppg.ff6c2c90eab28ca8b4a85882e0f4ae03.svg";
export { ForwardRef as ReactComponent };